module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-check-fill-b550f48c.svg";